<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Aforos</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                       aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="IdComunidadAutonoma">Comunidad Autónoma</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="comunidadesAutonomas"
                                               placeholder="-- Seleccione una Comunidad Autónoma --"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdComunidadAutonoma"
                                               [ngClass]="displayFieldCssNgSelect('IdComunidadAutonoma')"
                                               (change)="onSelectComunidadAutonoma($event)"
                                               notFoundText="Comunidad Autónoma no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="IdProvincia">Provincia</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="provincias"
                                               [readonly]="!provincias || provincias.length === 0"
                                               placeholder="-- Seleccione una Provincia --"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdProvincia"
                                               [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                               (change)="onSelectProvincia($event)"
                                               notFoundText="Provincia no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="IdRecinto">Recinto</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="recintos"
                                               [readonly]="!recintos || recintos.length === 0"
                                               placeholder="-- Seleccione una Recinto --"
                                               bindLabel="Titular"
                                               bindValue="Id"
                                               formControlName="IdRecinto"
                                               [ngClass]="displayFieldCssNgSelect('IdRecinto')"
                                               (change)="onSelectRecinto($event)"
                                               notFoundText="Recinto no encontrado"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Titular }}">{{ item.Titular }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="IdCultivo">Cultivo</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="cultivos"
                                               [readonly]="!cultivos || cultivos.length === 0"
                                               placeholder="-- Seleccione una Cultivo --"
                                               bindLabel="Variedad"
                                               bindValue="Id"
                                               formControlName="IdCultivo"
                                               [ngClass]="displayFieldCssNgSelect('IdCultivo')"
                                               notFoundText="Cultivo no encontrado"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Variedad }}">{{ item.Variedad }} <!-- Mostrar la descripción de la variedad --></div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="IdVariedad">Variedad</label>
                                    <ng-select appendTo="body"
                                               loadingText="Cargando..."
                                               [items]="variedades"
                                               placeholder="-- Seleccione una Variedad --"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdVariedad"
                                               [ngClass]="displayFieldCssNgSelect('IdVariedad')"
                                               notFoundText="Variedad no encontrada"
                                               clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="Descripcion">Descripción</label>
                                    <input formControlName="Descripcion" name="Descripcion" maxlength="100" class="form-control" id="Descripcion" type="text" value="">
                                </div>

                            </div>

                            <div class="row">
                                <div class="form-group col-md-2">
                                    <label class="col-form-label" for="Anyo">Año</label>
                                    <input formControlName="Anyo" name="Anyo" maxlength="4" class="form-control" id="Anyo" type="text" value="" (input)="onInputChange($event)">
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                                [disabled]="disableSearchBtn" title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button"
                                                [disabled]="formIsUntouched()"
                                                title="Limpia los filtros" (click)="onResetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
